const base = {
  default: {
    backgroundColor: 'coolGrey.10',
    '&.hasBorder': {
      height: '1px',
      backgroundColor: 'coolGrey.10',
    }
  }
};

const border = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    scale: base,
    spark: base
  }
};

export type BorderVariantsType = 'default';
export const borderVariants = Object.keys(base) as BorderVariantsType[];

export default border;
